const flows = {
  add_phone: {
    phone_step: {
      title: 'Agora, precisamos do seu número de celular para te manter informado.',
      label: 'Telefone',
      helper_text: 'Enviaremos um código de acesso para validar seu número de celular.',
      validations: {
        unexpected_error: 'Ocorreu um erro inesperado, tente novamente mais tarde.',
        invalid_cellphone: 'Telefone inválido. Por favor, revise e tente novamente.',
      },
    },
  },
  add_email: {
    email_step: {
      title: 'Informe seu e-mail para acompanhar suas solicitações.',
      label: 'email@email.com',
      helper_text: 'Enviaremos um código de validação para seu e-mail.',
      validations: {
        unexpected_error: 'Ocorreu um erro inesperado, tente novamente mais tarde.',
        invalid_email: 'Email inválido. Por favor, revise e tente novamente.',
      },
    },
  },
  shared: {
    access_code_step: {
      title: 'Informe o código que enviamos para\n{{claim}}',
      timer: {
        valid_access_code: 'Código válido por {{minute}}min{{second}}s',
        resend: 'Reenviar código',
      },
      validations: {
        invalid_access_code: 'Código de acesso inválido.',
        unexpected_error: 'Ocorreu um erro inesperado, tente novamente mais tarde.',
      },
    },
  },
};

export { flows };
